import { createSelector } from 'reselect';

export const getPositionList = createSelector(
  state => state.position.positionList,
  positionList => positionList || [],
);

export const positionLoadingStatus = state => state.position.loadingStatus;
